<template>
  <component
    :is="tag"
    class="button"
    :class="modifiers"
    v-bind="attributes"
    v-on="$listeners"
  >
    <slot>
      {{ text }}
    </slot>
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    isOutlined: {
      type: Boolean,
      default: false,
    },
    isLight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tag() {
      if (this.$attrs.href) return 'router-link';
      return 'button';
    },
    attributes() {
      const { href, ...attributes } = this.$attrs;
      if (!href && !attributes.type) {
        attributes.type = 'button';
      }
      if (href) {
        attributes.to = href;
      }
      return attributes;
    },
    modifiers() {
      return {
        button_light: this.isLight,
        button_outlined: this.isOutlined,
        [`button_size_${this.size}`]: Boolean(this.size),
      };
    },
  },
};
</script>

<style lang="stylus">
.button
  display inline-flex
  align-items center
  justify-content center
  vertical-align top
  font-family inherit
  text-decoration none
  font-size 1.2em
  text-align center
  font-weight 600
  letter-spacing .05em
  text-transform uppercase
  line-height 1
  max-width 100%
  height 3em
  background $c_bright
  color #fff
  padding 0 2em
  margin 0
  border 0
  outline none
  border-radius 0

  &:hover
  //&:focus
  &:active
    background-color darken(@background, 10%)
    color #fff

  &_outlined
    color $c_bright
    background-color #fff
    border solid 0.125em currentColor
    &:hover
      background-color @background-color
      color darken(@background, 10%)

  &_light
    background-color #fff
    color $c_bright
    &:hover
      background-color #eee
      color @color

  &_size_s
    font-size 1em

  &_size_xs
    font-size 0.9em

  &[disabled]
    background-color $c_bg
    color $c_dim
</style>
